import axiosInstance from './axiosInstance'
import { Account } from '../../types'
import { mockAccounts } from './mockData'

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const accountsApi = {
  getAll: async (): Promise<Account[]> => {
    await delay(500)
    return mockAccounts
  },

  getById: async (id: string): Promise<Account> => {
    await delay(300)
    const account = mockAccounts.find((a) => a.id === id)
    if (!account) throw new Error('Account not found')
    return account
  },

  create: async (data: Omit<Account, 'id' | 'createdAt' | 'updatedAt'>): Promise<Account> => {
    await delay(500)
    const newAccount: Account = {
      ...data,
      id: `acc-${Date.now()}`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
    mockAccounts.push(newAccount)
    return newAccount
  },

  update: async (id: string, data: Partial<Account>): Promise<Account> => {
    await delay(500)
    const index = mockAccounts.findIndex((a) => a.id === id)
    if (index === -1) throw new Error('Account not found')
    mockAccounts[index] = {
      ...mockAccounts[index],
      ...data,
      updatedAt: new Date().toISOString(),
    }
    return mockAccounts[index]
  },

  delete: async (id: string): Promise<void> => {
    await delay(500)
    const index = mockAccounts.findIndex((a) => a.id === id)
    if (index === -1) throw new Error('Account not found')
    mockAccounts.splice(index, 1)
  },

  search: async (query: string): Promise<Account[]> => {
    await delay(300)
    return mockAccounts.filter((a) =>
      a.name.toLowerCase().includes(query.toLowerCase()),
    )
  },
}
